import { createStyles } from '@material-ui/core/styles';
import { LumaTheme } from 'embeds/core/styles/getTheme';

export default ({ spacing: { unit } }: LumaTheme) =>
  createStyles({
    headerWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: `${unit * 1.5}px 0 ${unit * 1.5}px ${unit * 3}px`,
    },
    searchWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    selectAllCheckbox: {
      color: 'transparent !important',
    },
    hidden: {
      opacity: 0,
    },
  });
